import React, { Component } from 'react';

export default class ProgressBar extends Component {
    render() {
        const barWidth = {
            width: `${this.props.percentMastery}%`
        };

        let display;
        if (!this.props.referralCount) {
            display = (
                <>
                    <span className="component--progress-bar__percentage__value">{this.props.percentMastery}%</span>
                    <span className="component--progress-bar__percentage__label"> Mastery</span>
                </>
            );
        } else {
            display = <span className="component--progress-bar__percentage__value">{this.props.referralCount} of 2</span>
        }

        return (
            <React.Fragment>
                <div className="component component--progress-bar">
                    <div className="component--progress-bar__container">
                        <div style={barWidth} className={this.props.percentMastery > 0 ? 'component--progress-bar__container__bar non-zero' : 'component--progress-bar__container__bar'}></div>
                    </div>
                    <div className="component--progress-bar__percentage">
                        {display}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}